const num = (v) => Number(v) || 0;

export function toTrendSeries(months) {
  const rows = Array.isArray(months) ? months : [];
  return {
    labels: rows.map((m) => m.month),
    revenue: rows.map((m) => num(m.revenue)),
    expenses: rows.map((m) => num(m.expenses)),
    net: rows.map((m) => num(m.netProfit)),
  };
}

export function toAgingSeries(buckets) {
  const rows = Array.isArray(buckets) ? buckets : [];
  return { labels: rows.map((b) => b.bucket), amounts: rows.map((b) => num(b.amount)) };
}

export function toBreakdownSeries(breakdown) {
  const rows = Array.isArray(breakdown) ? breakdown : [];
  return { labels: rows.map((r) => r.accountName), amounts: rows.map((r) => num(r.amount)) };
}

export function toStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return { labels: rows.map((s) => s.status), counts: rows.map((s) => num(s.count)) };
}
